/* eslint-disable react/no-find-dom-node */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
import ReactDOM from 'react-dom';
import axios from 'axios';

const defaultMatch = /button|radio|select|input|textarea/i;

const QueryFirstChild = (elem, tagType) => {
  let matcher;
  if (tagType) {
    matcher = /tagType/i;
  } else {
    matcher = defaultMatch;
  }
  if (matcher.test(elem.tagName)) {
    return elem;
  }
  if (elem.children && elem.children.length > 0) {
    for (const c of elem.children) {
      const e = QueryFirstChild(c, tagType);
      if (e != null) {
        return e;
      }
    }
  }
  return null;
};

const QueryFirstChildFromRef = (ref, tagType) => {
  if (ref && ref.current) {
    const elem = ReactDOM.findDOMNode(ref.current);
    if (elem) {
      return QueryFirstChild(elem, tagType);
    }
  }
  return null;
};

export { QueryFirstChild, QueryFirstChildFromRef };

export const extractCSS = document => new Promise((resolve, reject) => {
  const getCSS = url => axios
        .get(url) // eslint-disable-line
    .then(res => res.data)
    .catch((err) => {
      // sometimes we'll get a CORS exception that browsers are now starting to throw, just ignore it
      // see https://stackoverflow.com/questions/48753691/cannot-access-cssrules-from-local-css-file-in-chrome-64/49160760#49160760
          console.error(err); // eslint-disable-line
      return '';
    });

  // grab all style elements and extract their contents
  const styles = Array.from(document.querySelectorAll('style'))
    .map(s => s.innerText)
    .join('\n');

  // In production, there are no <style> tags in the document.  Styling is served in a CSS file.  So check for any <link>
  // tags that reference CSS files and extract the contents.
  // We used to use document.styleSheets to access the stylesheets of the document, but according to MDN, that is
  // experimental and is expected to change in the future:
  // https://developer.mozilla.org/en-US/docs/Web/API/DocumentOrShadowRoot/styleSheets
  const promises = Array.from(document.querySelectorAll('link'))
    .map(link => link.href)
    .filter(href => href.endsWith('.css'))
    .map(getCSS);

  Promise.all(promises)
    .then(vals => resolve(`${styles}\n${vals.join('\n')}`))
    .catch(err => reject(err));
});
